import clientService from '@/services/clientService';
import habService from '@/services/habService';
import teamsService from '@/services/teamsService';
import { defineStore } from 'pinia';

export const UseClientStore = defineStore('client', {
  state: () => ({
    teamsRHPortalLink: '',
    rcuClient: { logo: '' },
  }),
  actions: {
    async getTeamsRhPortalLink() {
      await teamsService.getTeamsRhPortalLink();
    },
    async getClientInfoFromRcu() {
      await clientService.getClientInfoFromRcu();
    },
    async setClientInfo(rcuClient: any) {
      this.rcuClient = rcuClient;
    },
    setTeamsRHPortalLink(teamsRHPortalLink: string) {
      this.teamsRHPortalLink = teamsRHPortalLink;
    },
  },
});
